import { API_V2 } from './apiVersion';

export const ANALYTICS_ENDPOINTS = {
  SUPERADMIN: {
    TODAY_VISITORS:
      `${API_V2}/superadmin/analytics/visitors/today`,

    DAILY_VISITORS:
      `${API_V2}/superadmin/analytics/visitors/daily`,

    TODAY_GAME_PARTICIPANTS:
      `${API_V2}/superadmin/analytics/game-participants/today`,
  },
} as const;
